import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-405"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.407 9.998a.499.499 0 0 0-.626.33l-1.085 3.478a.5.5 0 0 0 .33.626.489.489 0 0 0 .148.022.5.5 0 0 0 .477-.351l1.085-3.479a.5.5 0 0 0-.329-.626zm3.908-7.912a3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.185 3.185 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.243-6.116zm0 5.369a2.172 2.172 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.22 1.22 0 0 1 .168.018l.104.014a1 1 0 0 0 .96-.444 3.675 3.675 0 0 1 6.165 0 1 1 0 0 0 .961.444l.104-.014a1.22 1.22 0 0 1 .168-.018 2.185 2.185 0 1 1 0 4.369zm-8.79 5.254a1 1 0 0 0 2 0 6.603 6.603 0 0 0-1-2 6.603 6.603 0 0 0-1 2zm8.935-.112-.665-.384.658-.38a.35.35 0 0 0-.35-.605l-.657.379v-.768a.35.35 0 0 0-.699 0v.768l-.658-.38a.35.35 0 0 0-.35.606l.658.38-.666.384a.35.35 0 0 0 .175.652.343.343 0 0 0 .175-.047l.666-.384v.76a.35.35 0 0 0 .7 0v-.76l.664.384a.343.343 0 0 0 .175.047.35.35 0 0 0 .175-.652z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }